import {useMutation, useQuery, useQueryClient} from '@tanstack/react-query';
import api from '../utils/axios.ts';
import {toast} from "react-hot-toast";
import getApiErrorMessage from '../utils/helper';

export const useGetProfile = () => {
  return useQuery({
    queryKey: ['profile'],
    queryFn: async () => {
      const { data } = await api.get('/members/my-profile');
      return data;
    },
  });
};

export const useToggleSetting = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (setting) => {
      const { data } = await api.post('/toggle-notification-setting', {
        'enable_notifications': setting
      });
      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['profile'] });
      toast.success('Notification setting updated successfully');
    },
    onError: (error) => {
      toast.error(getApiErrorMessage(error));
    },
  });
};

export const useUpdateNotificationSettings = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (settings) => {
      const { data } = await api.post('/toggle-notification-setting', settings);
      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['profile'] });
      toast.success('Notification settings updated successfully');
    },
    onError: (error) => {
      toast.error(getApiErrorMessage(error));
    },
  });
};